<template>
  <div class="login">
    <div class="login-ipt">
      <input type="text" class="login-ipt-input" v-model="loginName">
    </div>
    <div class="login-item"><button class="login-item-btn" @click="handleToLogin()">登陆</button></div>
  </div>
</template>

<script type="text/ecmascript-6">
import { post } from '../api/api'
export default {
  name: 'AssetsLogin',
  data () {
    return {
      loginName: ''
    }
  },
  methods: {
    async handleToLogin () {
      this.$cookies.remove('access_token')
      this.$cookies.remove('refresh_token')
      this.$cookies.remove('token_type')
      this.$cookies.remove('loginno')
      this.$cookies.remove('actorname')
      this.$cookies.remove('actorno')
      this.$cookies.remove('isGroup')
      const result = await post('/api/userLogin', {
        loginno: this.loginName,
        password: '',
        type: '1'
      })
      if (result.success) {
        this.$cookies.set('access_token', result.data.access_token, 60 * 60 * 24)
        this.$cookies.set('refresh_token', result.data.refresh_token, 60 * 60 * 24)
        this.$cookies.set('token_type', result.data.token_type, 60 * 60 * 24)
        this.$cookies.set('loginno', result.data.loginno, 60 * 60 * 24)
        this.$cookies.set('actorname', result.data.actorname, 60 * 60 * 24)
        this.$cookies.set('actorno', result.data.actorno, 60 * 60 * 24)
        this.$cookies.set('isGroup', result.data.isGroup, 60 * 60 * 24)
        this.$router.push('/homeassets')
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.login
  padding : 16px 16px 0 16px
  font-family: MyriadPro-Regular
  font-size: 34px
  font-weight: normal
  font-stretch: normal
  color : #4282e1
  .login-ipt
    border : 1px solid #8e8c8c
    .login-ipt-input
      padding : 16px 0 16px 16px
      height : 64px
      outline: none
      -webkit-appearance: none
      border:none
  .login-item
    margin-top : 32px
    .login-item-btn
      display : block
      width : 100%
      padding : 16px 0
</style>
